import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import type {
    ChecklistArguments,
    ChecklistArgumentsItem,
    ChecklistArgumentsNote,
    ChecklistArgumentsRequest,
} from "models/interfaces/conversations/tool-call-arguments/block-arguments";
import {
    ChecklistBlockRecord,
    ChecklistItemInputRecord,
} from "models/view-models/populated-blocks/populated-block-record";

const checklistArgumentsNoteDefaults: ChecklistArgumentsNote = {
    text: "",
};

export class ChecklistArgumentsNoteRecord
    extends Record(checklistArgumentsNoteDefaults)
    implements ChecklistArgumentsNote
{
    public with(
        values: Partial<ChecklistArgumentsNote>
    ): ChecklistArgumentsNoteRecord {
        return new ChecklistArgumentsNoteRecord(
            Object.assign(this.toJS(), values)
        );
    }
}

const checklistArgumentsItemDefaults: ChecklistArgumentsItem = {
    text: "",
    note: undefined,
};

export class ChecklistArgumentsItemRecord
    extends Record(checklistArgumentsItemDefaults)
    implements ChecklistArgumentsItem
{
    constructor(params?: Partial<ChecklistArgumentsItem>) {
        if (params?.note != null) {
            params.note = RecordUtils.ensureRecord(
                params.note,
                ChecklistArgumentsNoteRecord
            );
        }

        super(params);
    }

    public with(
        values: Partial<ChecklistArgumentsItem>
    ): ChecklistArgumentsItemRecord {
        return new ChecklistArgumentsItemRecord(
            Object.assign(this.toJS(), values)
        );
    }
}

const checklistArgumentsRequestDefaults: ChecklistArgumentsRequest = {
    type: "checklist",
    items: [],
};

export class ChecklistArgumentsRequestRecord
    extends Record(checklistArgumentsRequestDefaults)
    implements ChecklistArgumentsRequest
{
    constructor(params?: Partial<ChecklistArgumentsRequest>) {
        if (params != null) {
            params.items = RecordUtils.ensureRecords(
                params.items ?? [],
                ChecklistArgumentsItemRecord
            );
        }

        super(params);
    }

    public with(
        values: Partial<ChecklistArgumentsRequest>
    ): ChecklistArgumentsRequestRecord {
        return new ChecklistArgumentsRequestRecord(
            Object.assign(this.toJS(), values)
        );
    }
}

const checklistArgumentsDefaults: ChecklistArguments = {
    request: new ChecklistArgumentsRequestRecord(),
};

export class ChecklistArgumentsRecord
    extends Record(checklistArgumentsDefaults)
    implements ChecklistArguments
{
    constructor(params?: Partial<ChecklistArguments>) {
        if (params?.request != null) {
            params.request = RecordUtils.ensureRecord(
                params.request,
                ChecklistArgumentsRequestRecord
            );
        }

        super(params);
    }

    public with(values: Partial<ChecklistArguments>): ChecklistArgumentsRecord {
        return new ChecklistArgumentsRecord(Object.assign(this.toJS(), values));
    }

    public toPopulatedBlock(): ChecklistBlockRecord {
        return new ChecklistBlockRecord({
            items: this.request.items.map(
                (item) =>
                    new ChecklistItemInputRecord({
                        text: item.text,
                        note: item.note?.text,
                    })
            ),
        });
    }
}
